import { _ as __rest } from './tslib.es6-9c37295f.js';
import React__default from 'react';
import './index-3d331313.js';
import '@mantine/core';
import '@mantine/dates';
import './index-120855f6.js';
import './index-ed3e7858.js';
import './index-d943196d.js';
import './useMantineLocale-69ff962c.js';
import { T as Text$1 } from './index-bca4f215.js';
import './index-5b1256a3.js';
import './index.styles-d00e47f8.js';
import './translationsContext-0bb01e06.js';
import '@mantine/hooks';
import './utils-da0db738.js';
import './other-82ea32cf.js';
import './index-72b06055.js';

/**
 * @deprecated Consider to use import { Text } from '@hhgtech/hhg-components/mantine'
 */
const Text = (_a) => {
    var { size = 'base', type = 'regular' } = _a, rest = __rest(_a, ["size", "type"]);
    return (React__default.createElement(Text$1, Object.assign({ size: size, weight: type === 'caption' ? 'bold' : type, "data-size": size, "data-type": type, "data-word-wrap": rest.wordWrap, "data-is-uppercase": rest.isUppercase }, rest)));
};

export { Text as T };
